// @flow
import { Button } from 'antd'
import ModalEmailPreview from 'components/Modal/ModalEmailPreview'
import ModalTextMessagePreview from 'components/Modal/ModalTextMessagePreview'
import { Field, useFormikContext } from 'formik'
import { SettingsEmailMessageInput } from 'pages/Settings/SettingsEmailMessageInput'
import SettingsTextInputWithVariables from 'pages/Settings/SettingsTextInputWithVariables'
import * as React from 'react'
import Ui from 'ui'
import Flex from 'ui/atoms/Flex'
import Space from 'ui/atoms/Space'

const MAX_TEXT_MESSAGE_LENGTH = 160
const LENGTH_MIN_COLOR = [0, 0, 0, 0.54]
const LENGTH_MAX_COLOR = [200, 30, 30, 1]

const countChars = (text: string) => {
  const modifiedText = text.replace(/\{\{.*?\}\}/g, '-')
  return modifiedText.length
}

const clock = (min: number, max: number, ratio: number) =>
  min + (max - min) * ratio

function SettingsMessages(): React.Node {
  const { values } = useFormikContext()

  const { textMessage, emailMessage } = values

  const countTextMessage = countChars(textMessage)

  const [isPreviewEmailVisible, setIsPreviewEmailVisible] =
    React.useState(false)

  const [isPreviewTextVisible, setIsPreviewTextVisible] = React.useState(false)

  const textMessageLengthColor = React.useMemo(() => {
    const ratio = countTextMessage / MAX_TEXT_MESSAGE_LENGTH

    return `rgba(${clock(
      LENGTH_MIN_COLOR[0],
      LENGTH_MAX_COLOR[0],
      ratio
    )}, ${clock(LENGTH_MIN_COLOR[1], LENGTH_MAX_COLOR[1], ratio)}, ${clock(
      LENGTH_MIN_COLOR[2],
      LENGTH_MAX_COLOR[2],
      ratio
    )}, ${clock(LENGTH_MIN_COLOR[3], LENGTH_MAX_COLOR[3], ratio)})`
  }, [countTextMessage])

  return (
    <Space>
      <div>
        <Ui.QuestionTitle htmlFor="email_message">
          Email subject
        </Ui.QuestionTitle>
        <Field
          component={SettingsTextInputWithVariables}
          name="emailSubject"
          placeholder="Email subject"
        />
      </div>
      <div>
        <Flex align="center" className="relative" justify="between">
          <Ui.QuestionTitle htmlFor="email_message">
            Email message
          </Ui.QuestionTitle>
          <Button
            className="absolute right-0 top-0 z-[1] h-7 px-1 text-sm"
            onClick={() => setIsPreviewEmailVisible(true)}
            type="link"
          >
            Preview
          </Button>
        </Flex>
        <Field
          component={SettingsEmailMessageInput}
          name="emailMessage"
          placeholder="Email message"
        />
      </div>
      <div>
        <Flex align="center" className="relative" justify="between">
          <Ui.QuestionTitle htmlFor="text_message">
            Text message
            <span
              className="px-2 text-xs"
              style={{ color: textMessageLengthColor }}
            >
              {countTextMessage}/{MAX_TEXT_MESSAGE_LENGTH}
            </span>
          </Ui.QuestionTitle>
          <Button
            className="absolute right-0 top-0 z-[1] h-7 px-1 text-sm"
            onClick={() => setIsPreviewTextVisible(true)}
            type="link"
          >
            Preview
          </Button>
        </Flex>
        <Field
          multiline
          component={SettingsTextInputWithVariables}
          maxLength={160}
          name="textMessage"
          placeholder="Text message"
        />
      </div>
      <ModalEmailPreview
        canDismiss
        isVisible={isPreviewEmailVisible}
        message={emailMessage}
        onClose={() => setIsPreviewEmailVisible(false)}
      />
      <ModalTextMessagePreview
        canDismiss
        isVisible={isPreviewTextVisible}
        message={textMessage}
        onClose={() => setIsPreviewTextVisible(false)}
      />
    </Space>
  )
}

export default SettingsMessages
